<div class="speed-dots">
    <div class="dot" [ngClass]="{'filled': speed >= 1}"></div>
    <div class="dot" [ngClass]="{'filled': speed >= 15}"></div>
    <div class="dot" [ngClass]="{'filled': speed >= 30}"></div>
    <div class="dot" [ngClass]="{'filled': speed >= 45}"></div>
    <div class="dot" [ngClass]="{'filled': speed >= 60}"></div>
</div>
